module.exports = {
	"articleTitle1": "Renowned Detroit bakery to open an Ann Arbor location ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Avalon Cafe and Kitchen",
	"articleLink1": "https://www.michigandaily.com/section/business/renowned-detroit-bakery-opening-ann-arbor-cafe",
	"articleLink2": "https://www.michigandaily.com/section/arts/best-ann-arbor-2017-full-list",
	"articleSnippet1": "Oct 31, 2016 ... Detroit-based bakery Avalon International Breads is expanding outside ... the \nlocation of the former Mezzevino Mediterranean Kitchen and Bar on 129 ... The \nretail bakery will be named Avalon Hearth and Soul Café and is on ...",
	"articleSnippet2": "Apr 12, 2017 ... New Restaurant: Pretzel Bell. Coffee Shop: RoosRoast Coffee Works ... New \nRestaurant: Avalon Hearth and Soul Cafe and Kitchen. Coffee ...",
	"foodRecommendations": [],
	"articleTitle2": "Best of Ann Arbor 2017: Full List ",
	"address": "120 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161101/kev.NEW_.AvalonBakery.10.31.16.10.jpg?itok=pPeonSos",
			"author": "Kevin Zheng/ Daily",
			"caption": "Workers paint the upcoming Avalon Bakery, which will open in 6-8 weeks at 129 E Liberty St., on Monday."
		}
	],
	"position": {
		"lat": 42.279366,
		"lng": -83.7476
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/avalon.json
// module id = 818
// module chunks = 0